// extracted by mini-css-extract-plugin
export default {"container":"customizedCard_container__CkjGF","left":"customizedCard_left__zMYXX","right":"customizedCard_right__J19cq"};